import React from 'react'
import DatePicker from 'react-datepicker'

import { InputStyled } from '../Input/Input.styles'

interface Props {
  className?: string
  handleChange: (value: Date) => void
  minDate?: Date
  value: Date
}

export const DateInput = ({ className = '', handleChange, minDate, value }: Props) => {
  const onChange = (value: Date) => {
    handleChange(value)
  }

  return (
    <DatePicker
      className={className}
      css={InputStyled}
      minDate={minDate}
      onChange={onChange}
      placeholderText={'Select date'}
      selected={value}
      showPopperArrow={false}
      value={value}
    />
  )
}
